import { Link } from 'react-router-dom'
import './Error.css'

function Maintenance() {
  return (
    <div className="error-page maintenance">
      <div className="error-content">
        <div className="error-illustration">
          <svg width="200" height="200" viewBox="0 0 200 200" fill="none">
            <circle cx="100" cy="100" r="80" fill="url(#maint-gradient)" fillOpacity="0.1"/>
            <g transform="translate(70, 60)">
              <path d="M30 0L36 20H24L30 0Z" fill="url(#maint-gradient)"/>
              <rect x="20" y="20" width="20" height="50" rx="4" fill="url(#maint-gradient)"/>
              <circle cx="30" cy="35" r="6" fill="white"/>
            </g>
            <defs>
              <linearGradient id="maint-gradient" x1="0" y1="0" x2="200" y2="200">
                <stop stopColor="#7C3AED"/>
                <stop offset="1" stopColor="#2563EB"/>
              </linearGradient>
            </defs>
          </svg>
        </div>
        
        <h1 className="error-title">Scheduled Maintenance</h1>
        <p className="error-description">
          We're performing scheduled maintenance to improve your experience. 
          We'll be back online shortly.
        </p>
        
        <div className="maintenance-info">
          <div className="maintenance-time">
            <span className="time-label">Estimated completion</span>
            <span className="time-value">~30 minutes</span>
          </div>
        </div>
        
        <div className="error-actions">
          <a href="https://status.hubthrill.com" className="btn btn-primary" target="_blank" rel="noopener noreferrer">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <polyline points="12 6 12 12 16 14"/>
            </svg>
            Check status page
          </a>
          <a href="https://twitter.com/hubthrill" className="btn btn-secondary" target="_blank" rel="noopener noreferrer">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
            Follow for updates
          </a>
        </div>
        
        <div className="error-help">
          <p>Questions? <Link to="/support">Contact support</Link></p>
        </div>
      </div>
      
      <div className="error-decoration">
        <div className="decoration-orb orb-1"></div>
        <div className="decoration-orb orb-2"></div>
        <div className="decoration-orb orb-3"></div>
      </div>
    </div>
  )
}

export default Maintenance
